<script lang="ts">
  import { page } from '$app/stores';
  import RadioButton from '$components/ui/radio-button.svelte';
  import { region } from '$lib/region';
  import type { SizeTableStoryblok } from '$types/bloks';
  import { cva } from 'class-variance-authority';
  import { onMount } from 'svelte';

  const tableCell = cva('py-2.5 border-b border-r border-primary/8 [&:last-child]:border-r-0', {
    variants: {
      variant: {
        header:
          'font-semibold bg-primary/4 [&:first-child]:text-primary/60 first:w-[40px] uppercase',
        subheader:
          'font-semibold bg-primary/4 text-primary/60 first:w-[40px] uppercase text-[10px] md:text-xs',
        body: '[tr:last-child_&]:border-b-0 [&:first-child]:text-primary/60'
      }
    },
    defaultVariants: {
      variant: 'body'
    }
  });

  export let block: SizeTableStoryblok[] | undefined;

  let selectedUnit: string | undefined;
  $: units = block?.map((i) => String(i.unit));

  const getMergedHeaders = (headers: string[]) => {
    if (!headers.length) return [];

    const mergedHeaders = [];
    let currentValue = headers[0];
    let currentColspan = 1;

    for (let i = 1; i < headers.length; i++) {
      const nextValue = headers[i];

      if (nextValue === currentValue) {
        currentColspan++;
      } else {
        mergedHeaders.push({ value: currentValue, colspan: currentColspan });
        currentValue = nextValue;
        currentColspan = 1;
      }
    }

    // Push the last group
    mergedHeaders.push({ value: currentValue, colspan: currentColspan });

    return mergedHeaders;
  };

  onMount(() => {
    const regionalUnit = $page.data.configuration.content.default_regional_units?.find(
      (u) => u.region === $region
    );
    const availableUnit = units?.find((u) => u == regionalUnit?.unit);
    selectedUnit = availableUnit || units?.[0];
  });
</script>

{#if block && block.length > 0}
  {#if units && units.length > 0}
    <div class="flex flex-wrap gap-2 mb-3">
      {#each units as unit}
        <RadioButton value={unit} label={unit} id={unit} name="units" bind:group={selectedUnit} />
      {/each}
    </div>
  {/if}

  {#each block as sizeTable}
    {#if sizeTable.table && sizeTable.unit == selectedUnit}
      <div class={'rounded-xs overflow-hidden w-full border border-primary/8 text-xs'}>
        <table class={'w-full text-center table-fixed'}>
          <thead>
            <tr>
              {#each getMergedHeaders(sizeTable.table.thead.map((h) => h.value || '')) as header}
                <th
                  class={tableCell({
                    variant: sizeTable.hasTwoHeaderRows ? 'header' : 'subheader'
                  })}
                  colspan={header.colspan}
                >
                  {header.value || ''}
                </th>
              {/each}
            </tr>
          </thead>
          <tbody>
            {#each sizeTable.table.tbody as row, i}
              <tr>
                {#each row.body as cell}
                  <td
                    class={tableCell({
                      variant: sizeTable.hasTwoHeaderRows && i == 0 ? 'subheader' : 'body'
                    })}>{cell.value || ''}</td
                  >
                {/each}
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/if}
  {/each}
{/if}
